import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"super-container"}},[_c(VContent,{staticStyle:{"height":"100vh","text-align":"center"},attrs:{"id":"main-container"}},[_c('h1',{staticStyle:{"color":"orangered","font-size":"80px","margin-top":"20vh"}},[_vm._v("404")]),_c('p',{staticStyle:{"color":"#383838","font-size":"40px"}},[_vm._v("Page not found")]),_c(VBtn,{attrs:{"flat":"","color":"error"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Back")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }